var AccountMenuView = require('accountmenuview');
var BufferListView = require('bufferlistview');
var ts = require('../lib/util.es6').ts;


var SidebarView = Backbone.View.extend({
    el: '#sidebar',
    initialize: function (options) {
        this.bufferList = new BufferListView(options, this);
        this.accountMenu = new AccountMenuView(options, this);
        
        this.limitsContainer = $('#limits');
        this.wrapper = $('#sidebarwrapper');
        
        this.zombieWarnings = $('.zombieWarning');
        this.softZombieWarning = $('#softZombieWarning');
        this.hardZombieWarning = $('#hardZombieWarning');
        this.freeTrial = this.limitsContainer.find('.freeTrial');
        this.limitedTrial = this.limitsContainer.find('.limitedTrial');
        this.trialRemain = this.limitsContainer.find('.trialRemain');
        this.upgrade = this.$('.payUpgrade');
        this.updateWarning = this.$('.payUpdateWarning');
        
        this.model.bind('setZombie', this.renderZombieLimit, this);
        
        this.model.bind('init', this.init, this);
    },
    init: function () {
        this.renderLimits();
        this.model.bind('stat featureChange:upgrades', this.renderLimits, this);
    },
    renderZombieLimit: function () {
        this.zombieWarnings.hide();
        if (this.model.isZombied()) {
            if (this.model.hardZombie) {
                this.hardZombieWarning.show();
            } else if (this.model.softZombie && this.model.isZombieLimited()) {
                this.softZombieWarning.show();
            }
        }
    },
    renderLimits: function () {
        if (!this.model.isInitialized()) {
            this.limitsContainer.hide();
        } else {
            if (this.model.isUnlimited()) {
                this.limitsContainer.hide();
            } else {
                var unpaid = this.model.isSubscriptionUnpaid();
                this.upgrade.toggle(!unpaid);
                this.updateWarning.toggle(unpaid);
                var limited = this.model.isTrialLimited();
                this.limitedTrial.toggle(limited);
                this.freeTrial.toggle(!limited);
                var trialEnds = this.model.trialEnds();
                if (trialEnds) {
                    var trialEndsIn = trialEnds.getTime() - ts();
                    var days = Math.round(trialEndsIn/1000/24/60/60);
                    if (days <= 1) {
                        this.trialRemain.attr('title', 'Trial ends today').text('Ends today!');
                    } else {
                        this.trialRemain.attr('title', days + ' days remain on the trial').text(days + ' days');
                    }
                }
                this.limitsContainer.show();
            }
        }
        return this;
    },
    getRect: function () {
        return this.$el[0].getBoundingClientRect();
    }
});


module.exports = SidebarView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/sidebarview.js
// module id = gCfx
// module chunks = 1